export type SubscriptionLookup = {
  id: string | null
  userId: string
  customerId: string | null
  stripeSubscriptionId: string | null
  status: string | null
  unit: number | null
  unitPrice: number | null
  createdAt: string | null
  updatedAt: string | null
  cancelDate: string | null
  numberOfDrivers: number
}

export type CreateCheckoutSessionRequest = {
  userId: string
  unit: number
}

export type CreateCheckoutSessionResponse = {
  sessionId: string
  url: string | null
  clientSecret: string | null
  publishableKey: string
  amountTotalCents: number
  currency: string
}

export type CheckoutSessionStatusResponse = {
  sessionId: string
  status: string | null
  paymentStatus: string | null
  userId: string | null
  subscriptionId: string | null
  customerId: string | null
  stripeSubscriptionId: string | null
  unit: number | null
}

export type CreateSetupIntentRequest = {
  userId: string
}

export type CreateSetupIntentResponse = {
  setupIntentId: string
  clientSecret: string | null
  publishableKey: string
}

export type UpdatePaymentMethodRequest = {
  userId: string
  paymentMethodId: string
  invoiceId?: string | null
}

export type UpdatePaymentMethodResponse = {
  paymentMethodId: string
  stripeSubscriptionId: string | null
  invoiceId: string | null
  invoiceStatus: string | null
  invoicePaid: boolean
}

export type SubscriptionInvoice = {
  date: string | null
  paidDate: string | null
  status: string | null
  amount: number | null
  currency: string | null
  formattedAmount: string | null
  details: string | null
  invoiceId: string | null
  invoiceNumber: string | null
  viewInvoiceUrl: string | null
  downloadInvoiceUrl: string | null
  periodStart: string | null
  periodEnd: string | null
}

export const DEFAULT_DRIVER_UNIT_PRICE = 5

export const isSubscriptionInactive = (subscription?: SubscriptionLookup) => {
  if (!subscription?.cancelDate) {
    return false
  }
  const cancelTime = Date.parse(subscription.cancelDate)
  if (!Number.isFinite(cancelTime)) {
    return false
  }
  const cancelDay = new Date(cancelTime)
  const today = new Date()
  cancelDay.setHours(0, 0, 0, 0)
  today.setHours(0, 0, 0, 0)
  return cancelDay <= today
}

export const isCancelScheduled = (subscription?: SubscriptionLookup) =>
  Boolean(subscription?.id) &&
  Boolean(subscription?.cancelDate) &&
  !isSubscriptionInactive(subscription)

export const hasActiveSubscription = (subscription?: SubscriptionLookup) =>
  Boolean(subscription?.id) && !isSubscriptionInactive(subscription)

export const needsSubscriptionUpgrade = (subscription?: SubscriptionLookup) => {
  if (!hasActiveSubscription(subscription) || subscription == null) {
    return false
  }
  const units = subscription.unit ?? 0
  return subscription.numberOfDrivers >= units
}

export const formatCadMonthly = (amount: number) => {
  const rounded = Number.isInteger(amount) ? String(amount) : amount.toFixed(2)
  return `CAD ${rounded} / month`
}

export const formatCadAmount = (amount: number) => amount.toFixed(2)
